import { useState, useEffect } from "react";
import useSWR from "swr";
import * as listingApi from "@/api/listing";
import {fetchAPIRequestData} from "@/api/global";
import {getSolrClient} from '@/utils/solr';

export function useListingsSolrSearch(list_obj, pageLimit, pageOffset, q, solr_index) {
  const solrClient = getSolrClient();
  const new_query = q ? q : solrClient.assembleQuery(list_obj);
  const { data, error } = useSWR(['/api/solr', pageLimit, pageOffset, new_query, solr_index], ([url, pageLimit, pageOffset, new_query, solr_index]) => listingApi.listingsSolrSearch(url, pageLimit, pageOffset, new_query, solr_index));
  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  }
}

export function useListingsSolrMLTSearch(list_obj, pageLimit, pageOffset, q, solr_index) {
  const solrClient = getSolrClient();
  const new_query = q ? q : solrClient.assembleQuery(list_obj);
  const { data, error } = useSWR(['/api/solr', pageLimit, pageOffset, new_query, solr_index], ([url, pageLimit, pageOffset, new_query, solr_index]) => listingApi.listingsSolrMLTSearch(url, pageLimit, pageOffset, new_query, solr_index));

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  }
}

export function useContentDBSearch(settings) {
  let {url, query, opts, pageLimit, pageOffset, fetcher} = settings;
  // pageLimit = pageLimit || null;
  // pageOffset = pageOffset || 0;
  fetcher = fetcher || fetchAPIRequestData;

  const swrResp = useSWR([url, query, opts, pageLimit, pageOffset], ([url, query, opts, pageLimit, pageOffset]) => fetcher(url, query, opts, pageLimit, pageOffset), {});
  const {data, error} = swrResp;

  return {
    data: data,
    isLoading: !error && !data,
    isError: error,
  }
}

export const useOnScreen = (ref) => {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting)
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
  }, [])
  return isIntersecting;
}
